import React from 'react';
import { Flex } from '@edreamsodigeo/prisma-design-system';
import OtherDay from './OtherDay';
import SegmentTime from '../DepartureTime/SegmentTime';

export interface DestinationTimeProps {
  arrivalDate: string;
  departureDate: string;
}

const DestinationTime: React.FC<DestinationTimeProps> = ({
  arrivalDate,
  departureDate,
}) => {
  return (
    <Flex justifyContent={'flex-end'}>
      <SegmentTime date={arrivalDate} />
      <OtherDay departureDate={departureDate} arrivalDate={arrivalDate} />
    </Flex>
  );
};

export default DestinationTime;
